import React, { useState } from 'react';
import { withStyles } from "@material-ui/core/styles";
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

const styles = theme => ({
  updateButton: {
    textAlign: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    padding: 0,
    appearance: 'none',
  }
});


const UpdateDialog = ({ registration, classes }) => {
  //console.log('registration:', registration);
  const [show, setShow] = useState(!!registration.waiting);
  //console.log('show: ', show);

  const handleUpdate = () => {
    registration.update();
    //console.log('update()');
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    //console.log('skipwaiting');
    setShow(false);
    window.location.reload();
  };

  return show ? (
    <Dialog aria-labelledby="upgrade-dialog-title" open={show}>
      <DialogTitle id="upgrade-dialog-title">新しいバージョンがリリースされました。</DialogTitle>
      <button className={classes.updateButton} onClick={handleUpdate}>
        <DialogContent dividers>アップデート</DialogContent>
      </button>
    </Dialog>
  ) : (
      <></>
    );
};

export default withStyles(styles)(UpdateDialog);